module.exports = __webpack_public_path__ + "static/media/TP_Icon_Monthly.297b7532.png";